module.exports = __webpack_public_path__ + "static/media/orgChart.b4424b52.png";